import { EnumLabel } from "../constants";

export const formatEnum = (key: string) => {
  return EnumLabel[key] || key;
};
export default formatEnum;
